import { StatelessComponent } from 'react'
import * as cn from 'classnames'
import * as styles from 'styles/atoms/Alert.css'
import CloseButton from 'components/atoms/buttons/CloseButton'

export type AlertProps = {
  theme: 'danger' | 'warning' | 'success' | 'action'
  onDismiss?: () => void
}

const Alert: StatelessComponent<AlertProps> = (props) => {
  const {
    theme,
    children,
    onDismiss,
  } = props

  const notificationClasses = cn(styles.alert, {
    [styles.danger]: theme === 'danger',
    [styles.warning]: theme === 'warning',
    [styles.success]: theme === 'success',
    [styles.action]: theme === 'action',
  })

  return (
    <div className={ notificationClasses }>
      <div className={ styles.content }>{ children }</div>
      { onDismiss && (
        <CloseButton size='small' theme={ theme } onClick={ onDismiss } />
      )}
    </div>
  )
}

export default Alert
